import type { CableSnap } from '@ab-core/graphql/dist/index';
import { Container } from '@ab-core/grid';
import { Loader } from '@ab-core/loader';
import useText from '@ab-core/localization/src/useText';
import type { ModalType } from '@ab-core/modal';
import Modal from '@ab-core/modal';
import Spacer from '@ab-core/spacer';
import { productStore } from '@ab-core/store';
import type { TableHeaderType } from '@ab-core/table';
import { Table } from '@ab-core/table';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React, { useState } from 'react';
import { CableSnapTableDataRow } from './components/cableSnapTableDataRow';

type CableSnapModalType = Pick<ModalType, 'open' | 'onClose'>;

export const CableSnapModal: FC<CableSnapModalType> = (props) => {
    const { open = false, onClose } = props;
    const [loading, setLoading] = useState(false);
    const cableSnapsData = productStore.getters.useCableSnapData();

    const title = useText('cableSnapModal.title');
    const text = useText('cableSnapModal.text');

    const header: TableHeaderType = [
        'Länge',
        'Reduzierter Preis',
        <div key="aktion" className="flex-justify-content-end">
            Aktion
        </div>
    ];

    return (
        <Modal open={open} onClose={onClose} headerText={title} md={8} lg={7} xl={5}>
            {loading && <Loader />}
            <Container>
                <Spacer size="xs" />
                <Text>{text}</Text>
                <Spacer size="xs" />

                <Table<CableSnap>
                    header={header}
                    items={cableSnapsData}
                    mobileBreakpoint="none"
                    tableBodyRenderer={(item) => (
                        <CableSnapTableDataRow setModalLoading={setLoading} key={item.chargeNr} cableSnapData={item} />
                    )}
                />
            </Container>
        </Modal>
    );
};
